// A list's search, carried in history state to the page a row opens: its breadcrumb goes back to
// the same filtered list without the search riding in the page's own URL. A pasted link has no
// state, and gets the whole list.
const KEY = 'listQ';

export const listReturnState = (q: string | undefined) => ({ [KEY]: q });

export const listReturnQ = (state: object): string | undefined => {
  if (!(KEY in state)) return undefined;
  const value: unknown = state[KEY];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
};
